import { createSDK } from '../../../../packages/sdk/src/index';
import { DEFAULT_REFRESH_BEFORE_EXPIRY_MS } from '../../../../packages/sdk/src/types';
import { useAuthStore } from '../stores/authStore';
import { getApiBaseUrl } from './apiBaseUrl';

export const sdk = createSDK({
  baseURL: getApiBaseUrl(),
  getToken: () => window.localStorage.getItem('hria-token'),
  getRequestHeaders: () =>
    typeof window !== 'undefined' && (window as Window & { electronAPI?: unknown }).electronAPI
      ? { 'X-HRIA-Client': 'electron-desktop' }
      : {},
  onUnauthorized: () => {
    const { logout } = useAuthStore.getState();
    logout();
  },
  refreshBeforeExpiryMs: DEFAULT_REFRESH_BEFORE_EXPIRY_MS,
});
